// extracted by mini-css-extract-plugin
export default {"ul-nav":"Navigation_ul-nav__LaYX6","dark":"Navigation_dark__jvC7n","active":"Navigation_active__FP1Ee"};